// Copyright 2014 Cognitect. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

goog.provide("com.cognitect.transit.delimiters");

goog.scope(function() {

var delimiters = com.cognitect.transit.delimiters;
    
/**
 * @const
 * @type {string}
 */
delimiters.ESC     = "~";

/**
 * @const
 * @type {string}
 */
delimiters.TAG     = "#";

/**
 * @const
 * @type {string}
 */
delimiters.SUB     = "^";

/**
 * @const
 * @type {string}
 */
delimiters.RES     = "`";

/**
 * @const
 * @type {string}
 */
delimiters.ESC_TAG = "~#";

});
